import React, { useState } from "react";
import { formatMoney } from "../utils/utils";

const CompararPeriodoHonorario = () => {
  // Datos predefinidos de pagos por período
  const pagos = [
    { mes: 1, año: 2025, nombrePaciente: "Juan Pérez", nombreAuxiliar: "Ana López", dias: 20, total: 150000 },
    { mes: 2, año: 2025, nombrePaciente: "María García", nombreAuxiliar: "Carlos Ruiz", dias: 22, total: 160000 },
    { mes: 3, año: 2025, nombrePaciente: "Luis Martínez", nombreAuxiliar: "Sofía Díaz", dias: 21, total: 170000 },
    { mes: 4, año: 2025, nombrePaciente: "Laura Sánchez", nombreAuxiliar: "Pedro Gómez", dias: 23, total: 180000 },
    { mes: 5, año: 2025, nombrePaciente: "Carlos Fernández", nombreAuxiliar: "Lucía Torres", dias: 20, total: 190000 },
    { mes: 6, año: 2025, nombrePaciente: "Ana Rodríguez", nombreAuxiliar: "Jorge Ramírez", dias: 22, total: 200000 },
  ];

  // Estado para almacenar los períodos seleccionados
  const [periodo1, setPeriodo1] = useState("");
  const [periodo2, setPeriodo2] = useState("");
  const [detallesPeriodo1, setDetallesPeriodo1] = useState([]);
  const [detallesPeriodo2, setDetallesPeriodo2] = useState([]);

  const totalPeriodo1 = detallesPeriodo1.reduce((sum, pago) => sum + pago.total, 0);
  const totalPeriodo2 = detallesPeriodo2.reduce((sum, pago) => sum + pago.total, 0);

  // Función para buscar los detalles de un período
  const buscarDetalles = (periodo) => {
    const [año, mes] = periodo.split("-");
    return pagos.filter((p) => p.año === parseInt(año) && p.mes === parseInt(mes));
  };

  // Función para comparar los períodos
  const compararPeriodos = () => {
    if (!periodo1 || !periodo2) {
      alert("Por favor, selecciona ambos períodos.");
      return;
    }

    // Buscar los detalles de los períodos seleccionados
    const detalles1 = buscarDetalles(periodo1);
    const detalles2 = buscarDetalles(periodo2);

    setDetallesPeriodo1(detalles1);
    setDetallesPeriodo2(detalles2);
  };

  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h3 className="card-title">Comparar Períodos de Honorarios</h3>
        </div>
        <div className="card-body">
          {/* Formulario para seleccionar períodos */}
          <div className="row mb-4">
            <div className="col-md-6">
              <label htmlFor="periodo1" className="form-label">
                Período 1
              </label>
              <input
                type="month"
                className="form-control"
                id="periodo1"
                value={periodo1}
                onChange={(e) => setPeriodo1(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="periodo2" className="form-label">
                Período 2
              </label>
              <input
                type="month"
                className="form-control"
                id="periodo2"
                value={periodo2}
                onChange={(e) => setPeriodo2(e.target.value)}
              />
            </div>
          </div>

          {/* Botón para comparar */}
          <button className="btn btn-primary" onClick={compararPeriodos}>
            Comparar Períodos
          </button>

          {/* Tablas para mostrar los detalles */}
          <div className="row mt-4">
            <div className="col-md-6">
              <h4>Detalles del Período 1</h4>
              <h5>Total: ${formatMoney(totalPeriodo1)}</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Nombre del Auxiliar</th>
                    <th>Días</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {detallesPeriodo1.map((pago, index) => (
                    <tr key={index}>
                      <td>{pago.nombreAuxiliar}</td>
                      <td>{pago.dias}</td>
                      <td>${formatMoney(pago.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <h4>Detalles del Período 2</h4>
              <h5>Total: ${formatMoney(totalPeriodo2)}</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Nombre del Auxiliar</th>
                    <th>Días</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {detallesPeriodo2.map((pago, index) => (
                    <tr key={index}>
                      <td>{pago.nombreAuxiliar}</td>
                      <td>{pago.dias}</td>
                      <td>${formatMoney(pago.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompararPeriodoHonorario;